import { useRef, useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
const pageVariants = {
  initial: { opacity: 0, scale: 0.95, filter: "blur(4px)" },
  animate: { opacity: 1, scale: 1, filter: "blur(0px)" },
  exit: { opacity: 0, scale: 1.03, filter: "blur(4px)" },
};
const inputStyle = {
  padding: "18px 20px",
  borderRadius: "14px",
  border: "2px solid transparent",
  fontSize: "1rem",
  fontFamily: "var(--font-sans)",
  background: "rgba(255,255,255,0.07)",
  color: "#fff",
  outline: "none",
  width: "100%",
  transition: "border-color 0.3s, background 0.3s",
};
function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("");
  const [focused, setFocused] = useState(null);
  const [formState, setFormState] = useState({
    user_name: "",
    user_email: "",
    user_phone: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");
    const templateParams = {
      user_name: formState.user_name,
      user_email: formState.user_email,
      user_phone: formState.user_phone,
      message: formState.message,
    };
    emailjs
      .send(
        "service_a6bvzmk",
        "template_pnugeql",
        templateParams,
        "7lxVhoy8JXRzyRyB4",
      )
      .then(() => {
        setStatus("sent");
        form.current.reset();
        setFormState({
          user_name: "",
          user_email: "",
          user_phone: "",
          message: "",
        });
      })
      .catch(() => setStatus("error"));
  };
  const fieldStyle = (name) => ({
    ...inputStyle,
    borderColor: focused === name ? "var(--gold)" : "rgba(255,255,255,0.1)",
    background:
      focused === name ? "rgba(255,255,255,0.1)" : "rgba(255,255,255,0.06)",
  });
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.6, ease: "easeInOut" }}
    >
      <section
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(160deg, var(--ink) 0%, #2d0a4e 60%, #1a0a2e 100%)",
          padding: "140px 10% 100px",
          position: "relative",
          overflow: "hidden",
          color: "#fff",
        }}
      >
        {[
          {
            size: 400,
            top: "-100px",
            right: "-80px",
            bg: "var(--fuchsia)",
            op: 0.07,
          },
          {
            size: 300,
            bottom: "0px",
            left: "-60px",
            bg: "var(--teal)",
            op: 0.07,
          },
          { size: 150, top: "40%", right: "15%", bg: "var(--gold)", op: 0.08 },
        ].map((b, i) => (
          <motion.div
            key={i}
            animate={{ y: [0, -20, 0], rotate: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 7 + i * 2, delay: i }}
            style={{
              position: "absolute",
              width: b.size,
              height: b.size,
              borderRadius: "60% 40% 55% 45%/50% 60% 40% 55%",
              background: b.bg,
              opacity: b.op,
              top: b.top,
              bottom: b.bottom,
              left: b.left,
              right: b.right,
              zIndex: 0,
            }}
          />
        ))}
        <div style={{ position: "relative", zIndex: 1 }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              style={{
                fontFamily: "var(--font-hand)",
                fontSize: "1.4rem",
                color: "var(--gold)",
                letterSpacing: "2px",
              }}
            >
              ✦ Let's Connect ✦
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              style={{
                fontFamily: "var(--font-serif)",
                fontStyle: "italic",
                fontSize: "clamp(2.5rem, 6vw, 4rem)",
                fontWeight: 900,
                marginTop: "10px",
                background: "linear-gradient(135deg, #fff, var(--gold))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Contact Us
            </motion.h1>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
              gap: "60px",
              maxWidth: "1100px",
              margin: "0 auto",
            }}
          >
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <h2
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "1.8rem",
                  marginBottom: "24px",
                  color: "var(--gold)",
                }}
              >
                Get in Touch
              </h2>
              <p
                style={{
                  color: "rgba(255,255,255,0.7)",
                  lineHeight: 1.9,
                  fontWeight: 300,
                  marginBottom: "40px",
                }}
              >
                Whether you want to commission a mural, enrol in a course, or
                simply learn more about what we do — we'd love to hear from you.
              </p>
              {[
                { icon: "📍", label: "Location", val: "Porur, Chennai, India" },
                { icon: "📧", label: "Email", val: "artemclava0106@gmail.com" },
                { icon: "🎨", label: "Studio", val: "Open Mon–Fri, 10am–6pm" },
              ].map(({ icon, label, val }, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.5 + i * 0.1 }}
                  style={{
                    display: "flex",
                    gap: "16px",
                    alignItems: "flex-start",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      width: "46px",
                      height: "46px",
                      borderRadius: "12px",
                      background: "rgba(255,255,255,0.08)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.3rem",
                      flexShrink: 0,
                    }}
                  >
                    {icon}
                  </div>
                  <div>
                    <div
                      style={{
                        color: "var(--gold)",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                      }}
                    >
                      {label}
                    </div>
                    <div
                      style={{
                        color: "rgba(255,255,255,0.75)",
                        marginTop: "4px",
                      }}
                    >
                      {val}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
            <motion.form
              ref={form}
              onSubmit={sendEmail}
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "18px",
                background: "rgba(255,255,255,0.04)",
                padding: "40px",
                borderRadius: "28px",
                border: "1px solid rgba(255,255,255,0.08)",
                backdropFilter: "blur(10px)",
              }}
            >
              <input
                type="text"
                name="user_name"
                placeholder="Your Name"
                required
                value={formState.user_name}
                onChange={handleChange}
                style={fieldStyle("name")}
                onFocus={() => setFocused("name")}
                onBlur={() => setFocused(null)}
              />
              <input
                type="email"
                name="user_email"
                placeholder="Your Email"
                required
                value={formState.user_email}
                onChange={handleChange}
                style={fieldStyle("email")}
                onFocus={() => setFocused("email")}
                onBlur={() => setFocused(null)}
              />
              <input
                type="tel"
                name="user_phone"
                placeholder="Your Phone"
                required
                value={formState.user_phone}
                onChange={handleChange}
                style={fieldStyle("phone")}
                onFocus={() => setFocused("phone")}
                onBlur={() => setFocused(null)}
              />
              <textarea
                rows="5"
                name="message"
                placeholder="Your Message"
                required
                value={formState.message}
                onChange={handleChange}
                style={{ ...fieldStyle("message"), resize: "vertical" }}
                onFocus={() => setFocused("message")}
                onBlur={() => setFocused(null)}
              />
              <motion.button
                type="submit"
                disabled={status === "sending"}
                whileHover={
                  status !== "sending"
                    ? {
                        scale: 1.02,
                        boxShadow: "0 0 30px rgba(232,160,32,0.4)",
                      }
                    : {}
                }
                whileTap={{ scale: 0.98 }}
                style={{
                  padding: "18px",
                  borderRadius: "14px",
                  border: "none",
                  background:
                    status === "sending"
                      ? "rgba(232,160,32,0.5)"
                      : "linear-gradient(135deg, var(--gold), var(--coral))",
                  color: "#fff",
                  fontSize: "1.05rem",
                  fontFamily: "var(--font-sans)",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  cursor: status === "sending" ? "not-allowed" : "pointer",
                  transition: "all 0.3s",
                }}
              >
                {status === "sending" ? "✨ Sending..." : "Send Message ✦"}
              </motion.button>
              {status === "sent" && (
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  style={{
                    color: "var(--teal)",
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  ✅ Message sent! We'll get back to you soon.
                </motion.p>
              )}
              {status === "error" && (
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  style={{
                    color: "var(--coral)",
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  ❌ Failed to send. Please try again.
                </motion.p>
              )}
            </motion.form>
          </div>
        </div>
      </section>
    </motion.div>
  );
}
export default Contact;
